import { GET_FONTSIZEENABLED } from '../constants/action-types';
// import { GET_COLOURBLINDENABLED } from '../constants/action-types';

const initialState = {
    isFontSizeEnabled: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_FONTSIZEENABLED:
            return {
                isFontSizeEnabled: !state.isFontSizeEnabled
            };
        default:
            return state;
    }
};